import { createSelector } from 'reselect';
import { StoreState } from 'src/store/reducers';
import { IServiceLocation } from 'src/types/service-locations';

export const Selector = (state: StoreState) => state.serviceLocations.data.list;

export const selectNameSerLocations = createSelector(Selector, (items) => {
    const ids: { [key: string]: string } = {};

    items.forEach((item: IServiceLocation) => {
        ids[item.id] = item.title;
    });

    return ids;
});

export const selectNameServiceLocations = createSelector(Selector, (items) => {
    const arrSel: { label: string; value: number | string }[] = [];

    items.forEach((item: IServiceLocation) => {
        arrSel.push({ label: item?.title, value: item.id });
    });
    arrSel.sort((a: SelectObject, b: SelectObject) => {
        const textA = a.label.toUpperCase();
        const textB = b.label.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    return arrSel;
});

export const selectNameSerLocationsDropDown = createSelector(Selector, (items) => {
    const itemsRes: SelectObject[] = [];
    items.forEach((item: IServiceLocation) => {
        itemsRes.push({ value: item.id, label: item.title });
    });
    return itemsRes;
});
